import styled from 'styled-components';

export const INVSummaryBox = styled.div`
position:static;
width:100%;
margin-top: 22px;
height:38px;
display:flex;
flex-direction:row;
align-items:center;
justify-content:space-between;
`;

export const INVSummaryItem= styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:space-between;
`;

export const INVSummaryValue= styled.span`
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 18px;
color: #6D6D6D;
`;

export const CardLabel = styled.span<{ backgroundColor: string,padding:number,margin:number }>`
position:static;
margin-top:${props=>props.margin}px;
height:14px;
box-sizing:border-box;
background: ${props=>props.color};
border-radius: 2px;
padding:0px ${props=>props.padding}px;
display:flex;
align-items:center;
justify-content:center;
border-left: 2px solid ${props=>props.backgroundColor};
`;

export const CardLabelText = styled.span`
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 10px;
line-height: 12px;
text-transform: uppercase;
white-space:nowrap;
color:${props=>props.color};
`;
